<template>
  <v-data-table
    class="projects-data-table"
    :headers="headers"
    :items="projects"
    disable-pagination
    no-data-text="No data available"
    hide-default-footer
    fixed-header
    :dense="denseTables"
    :height="defaultTableHeight"
    :sort-by="['title']"
    @click:row="navigateToDetails"
  >
    <template #item.start_date="{ item }">
      {{ item.start_date | dateToDisplay(dateFormatSettings) }}
    </template>

    <template #item.end_date="{ item }">
      {{ item.end_date | dateToDisplay(dateFormatSettings) }}
    </template>

    <template #footer>
      <v-divider />
      <v-row class="table-footer">
        <div class="footer-text">Total records: {{ projects.length }}</div>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex';

import { defaultTableHeight } from '@/constants/tableHeights';
import { DateHelper } from '@/helpers/date.helper';

export default {
  filters: {
    dateToDisplay: DateHelper.formatDateAccordingSettings,
  },
  props: {
    projects: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      defaultTableHeight,
      headers: [
        {
          text: 'Project',
          value: 'title',
        },
        {
          text: 'Office',
          value: 'office_name',
          width: '300px',
        },
        {
          text: 'Type',
          value: 'type',
          width: '200px',
        },
        {
          text: 'Start Date',
          value: 'start_date',
          width: '120px',
        },
        {
          text: 'End Date',
          value: 'end_date',
          width: '120px',
        },
        {
          text: 'Status',
          value: 'status',
          width: '250px',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user/settings', [
      'denseTables',
      'dateFormatSettings',
    ]),
  },
  methods: {
    navigateToDetails(item) {
      this.$router.push({ name: 'Project Details', params: { id: item.id, project: item } });
    },
  },
};
</script>

<style lang="less">
  @import "~variables";
  .projects-data-table {
    font-size: @table-font-size;

    tr {
      cursor: pointer;
    }
  }
</style>
